import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useUserPermissions } from '../hooks/useUserPermissions'
import PageSkeleton from './PageSkeleton'

type ProtectedRouteProps = {
  children: React.ReactNode
  requiredPermission?: string
}

function isTeamMemberUser(): boolean {
  try {
    const raw = localStorage.getItem('dizeeUser')
    const user = raw ? JSON.parse(raw) : null
    return !!user?.professionRole && ['manager', 'support', 'promoter'].includes(user.professionRole)
  } catch {
    return false
  }
}

export default function ProtectedRoute({ children, requiredPermission }: ProtectedRouteProps) {
  const navigate = useNavigate()
  const location = useLocation()
  const { hasPermission, loading } = useUserPermissions()

  useEffect(() => {
    if (loading) return

    // If no specific permission required, allow access
    if (!requiredPermission) return

    // Check if user has permission
    if (!hasPermission(requiredPermission)) {
      console.warn(`Access denied to ${location.pathname}: missing permission '${requiredPermission}'`)
      // Send team members to team-hub (not / which would redirect back here causing a loop)
      const dest = isTeamMemberUser() ? '/team' : '/'
      navigate(dest, { replace: true })
    }
  }, [loading, hasPermission, requiredPermission, navigate, location.pathname])

  if (loading) {
    return <PageSkeleton />
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return null
  }

  return <>{children}</>
}
